import { useParams } from 'react-router-dom';
import {
  DestinationSettings,
  DestinationSettingsProps
} from '../DestinationSettings/DestinationSettings';
import { DestinationAPI } from '../api/DestinationAPI';
import { EntityFormState } from '../../entity-form/interfaces/entity-form';
import { templateFormConnectionParamsFactory } from '../../template-form/factories/templateFormConnectionParamsFactory';
import { Destination } from '../../shared/interfaces/destination';
import { ResolvedComponent } from '../../routing/ResolvedComponent';
import { EditEntity } from '../../shared/components/EditEntity/EditEntity';
import { DestinationFactory } from '../DestinationList/factories/destinationFactory';

export function EditDestination() {
  const { id } = useParams();

  const destinationResolver = () =>
    DestinationAPI.getDestination(Number(id!)).then(res => DestinationFactory(res.data));

  return (
    <ResolvedComponent
      Component={EditDestinationInner}
      componentProps={{
        cancelUrl: '../configuration'
      }}
      resolve={{
        destination: destinationResolver
      }}
    />
  );
}

export function EditDestinationInner({
  destination,
  cancelUrl
}: {
  destination: Destination;
  cancelUrl: string;
}) {
  const formDataResolver = () => {
    return DestinationAPI.getDestinationConfigTemplateWithFormData(destination.id);
  };

  const formSubmitResolver = (values: EntityFormState) => {
    const connectionParams = templateFormConnectionParamsFactory(values);

    return DestinationAPI.editDestination(destination.id, connectionParams);
  };

  const testConnectionResolver = (values: EntityFormState) => {
    const buildParams = templateFormConnectionParamsFactory(values);
    return DestinationAPI.getTestConnectionTaskIdForDestinationEdit(destination.id, buildParams);
  };

  return (
    <EditEntity<DestinationSettingsProps>
      name={destination.name}
      FormComponent={DestinationSettings}
      componentProps={{
        formDataResolver,
        formSubmitResolver,
        testConnectionResolver,
        mode: 'EDIT'
      }}
      cancelUrl={cancelUrl}
      isCancelUrlPathRelative
    />
  );
}
